import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import Zoom from '@mui/material/Zoom';

const ErrorModal = ({ apiRes, setApiRes }) => {
  const handleClose = () => {
    setApiRes(prev => ({
      ...prev,
      axiosError: false,
    }));
  };
  return (
    <Dialog
      open={apiRes?.axiosError}
      onClose={handleClose}
      TransitionComponent={Zoom}
      transitionDuration={350}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          position: 'relative',
          borderRadius: '16px',
          padding: '12px',
          backgroundColor: '#FFF1F2',
          border: '1px solid #FCA5A5',
          boxShadow: '0 20px 25px -5px rgba(185, 28, 28, 0.1), 0 10px 10px -5px rgba(185, 28, 28, 0.04)',
        },
      }}
      disableEscapeKeyDown
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          color: '#B91C1C',
          opacity: 0.7,
          '&:hover': {
            opacity: 1,
            backgroundColor: 'rgba(185, 28, 28, 0.08)',
          },
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            pt: 2,
          }}
        >
          <Box
            sx={{
              p: 1.5,
              backgroundColor: '#FEE2E2',
              borderRadius: '50%',
              display: 'inline-flex',
              mb: 2,
            }}
          >
            <CloudOffIcon sx={{ fontSize: '36px', color: '#B91C1C' }} />
          </Box>

          <Typography variant="h6" sx={{ color: '#991B1B', fontWeight: 700, mb: 1 }}>
            {apiRes?.errHeading}
          </Typography>

          <Typography variant="body2" sx={{ color: '#B91C1C', mb: 4, opacity: 0.9, lineHeight: 1.6 }}>
            We encountered an unexpected  error. Please contact the Proposal Generator app development team for assistance.
          </Typography>

          <Button
            variant="contained"
            onClick={handleClose}
            fullWidth
            sx={{
              backgroundColor: '#B91C1C',
              color: '#FFFFFF',
              fontWeight: 600,
              padding: '10px',
              textTransform: 'none',
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: '#991B1B'
              },
            }}
          >
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

ErrorModal.propTypes = {
  apiRes: PropTypes.object.isRequired,
  setApiRes: PropTypes.func.isRequired,
};

export default ErrorModal;